import { MINT } from './types'

export const mintList: MINT[] = [
  {
    id: 'Tanuki',
    address: '0x0DB80faf96Aa985EDb70CBd1aa63872Cc02d2c32',
    isActive: true,
    name: 'Tanuki',
    desc: '3333 Tanuki NFTs, amulets for your crypto journey.',
    bannerImg: '/images/mints/banner_01.png',
    projectImg: '/images/mints/Tanuki.gif',
    total: 3333,
    salePrice: 3555,
    discountPrice: 2844,
    startTime: 1661486400000,
    presaleEndTime: 1661659200000,
    version: 1,
    presale: [
      {
        name: 'Free Mint',
        salePrice: 0,
        maxAmount: 1,
      },
      {
        name: 'Discount Mint',
        salePrice: 2844,
        maxAmount: 1,
      },
    ],
    publicSale: {
      name: 'Public Mint',
      salePrice: 3555,
      maxAmount: 10,
    },
    twitter: 'https://twitter.com/yokaiswap',
    discord: 'https://discord.gg/zr7u9FJeV5',
    medium: 'https://medium.com/@yokaiswap',
  },
]
